import { HOME_SUGGEST_ARTICLE_PROMPT, HOME_SUGGEST_ARTICLE_SUCCESS } from 'mk/autogenerated/translations/Home.sagas.190ef10aff011b8a37f301ee0471dfad'
import { homepage_api_posts_url, homepage_api_suggest_url, homepage_api_url } from 'mk/urls/functions';
import { PostSchema, TopicSchema } from 'mk2/apps/forum/schemas';
import {
    HOME_LOAD,
    HOME_LOAD_PAGE,
    HOME_SUGGEST_ARTICLE,
    HomeLoadAction,
    homeLoadApi,
    HomeLoadPageAction,
    homeLoadPageApi,
    HomeSuggestArticleAction,
    homeSuggestArticleApi,
} from 'mk2/apps/home/containers/Home/Home.actions';
import { HomeCounsellingSchema, HomePhotoblogPostSchema, HomePostSchema } from 'mk2/apps/home/schemas';
import { MinStrollerSchema } from 'mk2/apps/strollers/schemas';
import { ArticleSchema, ExperienceSchema } from 'mk2/apps/wiki/schemas';
import { handleXHRGetErrorSaga, normalizeError, XHRAction, XHRGetError } from 'mk2/helpers/api';
import { showSuccessToast } from 'mk2/helpers/toasts';
import { getLogger } from 'mk2/logger';
import { getRequestDeviceMobile } from 'mk2/reducers';
import { normalize } from 'normalizr';
import * as React from 'react';
import { all, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';

const logger = getLogger('home/Home.sagas');

function* load({ xhr }: HomeLoadAction & XHRAction) {
    const mobile = yield select(getRequestDeviceMobile);

    yield put(homeLoadApi.request());

    try {
        const response = yield call(
            () => xhr.get(homepage_api_url(), { mobile }),
        );
        const normalizedResponse = normalize(response.body, {
            forum: { posts: [PostSchema] },
            contests: { posts: [PostSchema], topic: TopicSchema },
            wiki: { articles: [ArticleSchema], experiences: [ExperienceSchema] },
            photoblog: { posts: [HomePhotoblogPostSchema] },
            homepage: { posts: [HomePostSchema] },
            counselling: {counsellings: [HomeCounsellingSchema]},
            strolleropedia: {strollers: [MinStrollerSchema]},
        });
        yield put(homeLoadApi.success(
            response.body.homepage.nextPage,
            response.body.bazaar.counts,
            response.body.lastVisitCountFriends,
            normalizedResponse,
        ));
    } catch (error) {
        yield handleXHRGetErrorSaga(error as XHRGetError, logger);
        yield put(homeLoadApi.failure(normalizeError(error)));
    }
}

function* loadPage({ xhr, page }: HomeLoadPageAction & XHRAction) {
    const mobile = yield select(getRequestDeviceMobile);

    yield put(homeLoadPageApi.request(page));

    try {
        const response = yield call(
            () => xhr.get(homepage_api_posts_url(page), { mobile }),
        );
        const normalizedResponse = normalize(response.body, {
            posts: [HomePostSchema],
        });

        yield put(homeLoadPageApi.success(page, response.body.nextPage, normalizedResponse));
    } catch (error) {
        yield handleXHRGetErrorSaga(error as XHRGetError, logger);
        yield put(homeLoadPageApi.failure(page, normalizeError(error)));
    }
}

const DEFAULT_LINK = 'https://';
function* suggestArticle({ xhr }: HomeSuggestArticleAction & XHRAction) {
    const link = prompt(HOME_SUGGEST_ARTICLE_PROMPT, DEFAULT_LINK);

    if (!link || link === DEFAULT_LINK) {
        return;
    }

    yield put(homeSuggestArticleApi.request());

    try {
        const response = yield call(
            () => xhr.post(homepage_api_suggest_url(), { link }),
        );

        yield put(homeSuggestArticleApi.success(response.body));

        yield showSuccessToast(HOME_SUGGEST_ARTICLE_SUCCESS);
    } catch (error) {
        yield handleXHRGetErrorSaga(error as XHRGetError, logger);
        yield put(homeSuggestArticleApi.failure(normalizeError(error)));
    }
}

export default function* root() {
    yield all([
        takeLatest(HOME_LOAD, load),
        takeLatest(HOME_LOAD_PAGE, loadPage),
        takeEvery(HOME_SUGGEST_ARTICLE, suggestArticle),
    ]);
}
